export const getCountryCities = (countryId, countryArr) => {
  const country = countryArr.find((country) => country.id === countryId)
  return country ? country.cities : []
}
